import React from 'react';
import { ImageOverlay } from 'react-leaflet';
import { OverlayResult } from '../../lib/types';

interface PngRasterOverlayProps {
  active: boolean;
  overlay: OverlayResult;
  keyBase: string;
  opacity: number;
  /**
   * Optional CSS z-index applied to the layer's <img> element within its
   * Leaflet pane. Use to force paint order between sibling overlays in the
   * same pane (default `overlayPane`, z=400) without spinning up a custom
   * pane. Example: the private-timberland focus mask sets `zIndex={10}` so
   * it always paints above the categorical Forest Ownership PNG, regardless
   * of mount order.
   *
   * Forwarded to Leaflet's `ImageOverlayOptions.zIndex`.
   */
  zIndex?: number;
}

/**
 * Renders a precomputed S3 PNG overlay (WHP, Species, SD, FO, mask, etc.)
 * as a Leaflet ImageOverlay. No-op when inactive or the hook hasn't
 * resolved bounds yet, so callers can render unconditionally and rely on
 * `active`.
 *
 * Must be rendered as a child of `<MapContainer>` — ImageOverlay needs map
 * context. Use OverlayResult directly from the per-layer hook.
 */
export const PngRasterOverlay: React.FC<PngRasterOverlayProps> = ({
  active,
  overlay,
  keyBase,
  opacity,
  zIndex,
}) => {
  if (!active || !overlay.url || !overlay.bounds) return null;
  return (
    <ImageOverlay
      key={keyBase}
      url={overlay.url}
      bounds={overlay.bounds}
      opacity={opacity}
      zIndex={zIndex}
    />
  );
};
